import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "container-file-component__document-side" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "name"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "container-file-component__thumbnail-section-thumbnail"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "container-file-component__thumbnail-section-drag-here"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "lds-roller" }, [
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div"),
  /*#__PURE__*/_createElementVNode("div")
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "container-file-component__thumbnail-section-thumbnail"
}
const _hoisted_13 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["container-file-component", { 'dragging-on': _ctx.isDragged }]),
    onDrop: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.dropEvent && _ctx.dropEvent(...args))),
    onDragenter: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.dragEnterService && _ctx.dragEnterService(...args))),
    onDragleave: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.dragLeaveService && _ctx.dragLeaveService(...args))),
    onDragover: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.preventDefault && _ctx.preventDefault(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (
                    _ctx.hasError && _ctx.hasError.has && !_ctx.hasError.has('documentImage')
                )
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.headerFile)), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: _normalizeClass(["container-file-component__upload-section", [
                    _ctx.isDetectedMobileDevice.value && !_ctx.imageString
                        ? 'change-if-mobile-device'
                        : '',
                ]])
      }, [
        (!_ctx.isFilled || _ctx.isUploadError)
          ? (_openBlock(), _createElementBlock("label", {
              key: 0,
              ref: "labelRef",
              for: _ctx.name,
              class: "upload-btn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkFileUploaded && _ctx.checkFileUploaded(...args)))
            }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.chooseFile`)), 9, _hoisted_3))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          id: _ctx.name,
          ref: "inputRef",
          type: "file",
          name: _ctx.name,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.updateFile && _ctx.updateFile(...args)))
        }, null, 40, _hoisted_4)
      ], 2),
      (!_ctx.isDetectedMobileDevice.value || _ctx.imageString)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "container-file-component__thumbnail-section",
            style: _normalizeStyle({ 'margin-left': !_ctx.file ? '10px' : '0' })
          }, [
            (!_ctx.isHEIF)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_ctx.isFilled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("img", {
                          class: "normal-picture-element",
                          src: _ctx.imageString,
                          alt: "picture of document"
                        }, null, 8, _hoisted_7),
                        _createElementVNode("span", {
                          class: "short-info remove-picture",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.removePhoto`)), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (!_ctx.isFilled)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                    : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("img", {
                          class: "heic-picture-element",
                          src: _ctx.imageString,
                          alt: "picture of document"
                        }, null, 8, _hoisted_13),
                        _createElementVNode("button", {
                          type: "button",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                        }),
                        _createElementVNode("span", {
                          class: "short-info remove-picture",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
                        }, _toDisplayString(_ctx.$t(`${_ctx.TRANSLATION_KEY}.removePhoto`)), 1)
                      ]))
                ]))
          ], 4))
        : _createCommentVNode("", true)
    ])
  ], 34))
}